import { Schema } from '../schema.js';
import { Model, PropertyPath } from '../engine.js';
import { ListType, ObjectType, Property, Type, TypeKind, TypeReference, UnionType } from '../types.js';
import { ModelSystemProperties } from '../internal/ModelSystemProperties.js';

export const ROOT_PROPERTY = '$';

export enum SourceType {
  Single,
  ListCommon,
  ListCommonElement,
  ListCommonForNested,
  ListCommonForNestedElement,
  ListSpecific,


}

export interface PropertyParentTuple {
  property: Property;
  parent?: PropertyValue;
}

export interface PropertyValue extends PropertyParentTuple {
  value: any;
}

export function pathToRoot(propertyValue: PropertyValue, keepRoot = true) {
  let path = [propertyValue.property.name];
  let parent = propertyValue.parent;
  while (parent) {
    if (!keepRoot && parent.property.name === '$') break;
    path.push(parent.property.name);
    parent = parent.parent;
  }
  return path.reverse().join('.');
}

export class PropertyPathWalker {
  private readonly propertyNames: string[];

  private step: number = 0;
  private currentPropertyValue: PropertyValue | undefined;


  constructor(public propertyPath: PropertyPath, public schema: Schema, model: Model, type: TypeReference) {
    this.propertyNames = propertyPath.split('.');
    // if (this.propertyNames[0] && this.propertyNames[0] === ROOT_PROPERTY) {
    // 	this.propertyNames.shift();
    // }
    this.currentPropertyValue = { value: model, property: new Property(ROOT_PROPERTY, type) };
  }

  // constructor(public propertyPath: PropertyPath, public schema: Schema, model: Model, type: TypeReference, ) {
  // 	this.propertyNames = propertyPath.split(".");
  // 	this.currentPropertyValue = {value: model, property: new Property(ROOT_PROPERTY, type)};
  // }

  getPropertyValue(): PropertyValue | undefined {
    let lastPropertyValue: any = undefined;
    while (true) {
      let tmp = this.next();
      if (tmp) {
        lastPropertyValue = tmp;
      } else {
        return lastPropertyValue;
      }
    }
  }

  // visible for tests
  next(): PropertyValue | undefined {
    if (this.propertyNames.length <= this.step || !this.currentPropertyValue) {
      return;
    }
    let currentPropertyName = this.propertyNames[this.step];
    let currentType: Type = this.schema.getType(this.currentPropertyValue.property.type);
    // if (this.currentPropertyValue.property) {
    // 	currentType = this.schema.getType(this.currentPropertyValue.property.type);
    // }

    let currentProperty: Property | undefined;
    // Replace UnionType with real runtime Type
    if (currentType instanceof UnionType) {
      const types = (currentType as UnionType).types;
      const originValue = this.currentPropertyValue.parent.value[this.currentPropertyValue.property.name];
      const runtimeTypeRef = ModelSystemProperties.getTypeRef(originValue);
      if (!runtimeTypeRef) {
        throw new Error(`Cannot determine runtime type of ${currentType.name}. Try to use Options`)
      }
      const runtimeType = this.schema.getType(runtimeTypeRef);
      if (!types.find(t => t === runtimeType.name)) {
        throw new Error(`Type '${runtimeType.name}' is not in a list of ${currentType.name} union`)
      }
      this.currentPropertyValue.property = { ...this.currentPropertyValue.property, type: runtimeType.name };
      currentType = runtimeType;
    }
    switch (currentType.kind) {
      case TypeKind.Object:
        currentProperty = (currentType as ObjectType).getProperty(currentPropertyName);
        break;
      case TypeKind.List: {
        let elementType = this.schema.getType((currentType as ListType).elementType);
        let elementIndex = Number.parseInt(currentPropertyName);
        if (Number.isNaN(elementIndex)) {
          if (elementType.kind !== TypeKind.Object) {
            throw new Error('Cannot go deeper inside list which doesn\'t contain objects');
          }
          // if (this.propertyNames.length > this.step + 1) {
          //   throw new Error('Cannot go deeper inside list');
          // }
          currentProperty = (elementType as ObjectType).getProperty(currentPropertyName);
        } else {
          currentProperty = new Property(currentPropertyName, elementType.getTypeReference(), {})
        }
      }
    }
    if (currentProperty) {
      this.currentPropertyValue = {
        value: this.currentPropertyValue.value ? this.currentPropertyValue.value[currentPropertyName] : undefined,
        property: currentProperty,
        parent: this.currentPropertyValue
      };
    } else {
      this.currentPropertyValue = undefined;
    }
    this.step++;
    return this.currentPropertyValue;
  }
}
